import * as ch from '@chakra-ui/react';

const traverseStyle = (source, fn, acc) => {
	if (Array.isArray(source)) return (() => fn(...source))();
	if (typeof source === 'object')
		return Object.keys(source).reduce(
			(acc, key) => ({ [key]: traverseStyle(source[key], fn, {}), ...acc }),
			{}
		);
	return source;
};

const parseStyleData = styleObject => cm => traverseStyle(styleObject, cm, {});

export const makeUI = data => cm =>
	Object.keys(data).reduce((acc, key) => {
		const { tag, ...styled } = data[key];
		const tagStyle = parseStyleData(styled);
		const Component = ch[tag];
		return {
			[key]: ({ children, ...rest }) => (
				<Component {...{...tagStyle(cm), ...rest}}>{children}</Component>
			),
			...acc,
		};
	}, {});
